import React from 'react'
import classNames from 'classnames'
import { Swiper } from 'swiper/react'
import styles from './Carousel.module.scss'
import { CarouselProps } from './Carousel.types'
import 'swiper/css'

const Carousel = ({ children, loop = true, ...props }: CarouselProps) => {
  return (
    <Swiper
      {...props}
      loop={loop}
      wrapperClass={classNames(styles.carousel, props?.wrapperClass)}>
      {children}
    </Swiper>
  )
}

export { Carousel }
